import React from 'react';

function NotFound(props) {

    return (
        <>
            <h1>페이지를 찾을 수 없습니다.</h1>
        </>
    );
}

export default NotFound;
